import {defineStore} from 'pinia'
import JSZip from 'jszip'
import jspdf from "jspdf"
import autoTable from 'jspdf-autotable'
import {mappingTable, schema} from "./mappingtable.ts";

import {
    Dialog,
} from 'quasar'

import FileSaver from 'file-saver'
import {useCalculatorStore} from "./calculator.store.js";

export const useTransactionStore = defineStore('transaction', {
    getters: {
        tableConfigurations: () => {
            const calculatorStore = useCalculatorStore()
            return {
                notderated: {
                    title: 'Free-Field Values at the Focus',
                    columns: [
                        {title: "Fundamental Frequency", dataKey: "frequency_MHz"},
                        {title: "Pressure Amplitude [MPa]", dataKey: "ppp_mpa"},
                        {title: "Peak Negative pressure [MPa]", dataKey: "pnp_mpa"},
                        {title: "Isppa [W/cm2]", dataKey: "isppa"},
                        {title: "Non-derated MI", dataKey: "non_derated_MI"},
                        {title: "Ispta of pulse train [W/cm2]", dataKey: "ispta_pulse_train"},
                        {title: "Ispta of pulse train repetition [W/cm2]", dataKey: "ispta_pulse_train_repetition"},
                        // {title: "delta °C in brain", dataKey: "temp_rise"},
                        {title: "Energy deposition [J/cm2]", dataKey: "energy_deposition"},
                        {title: "Rate of energy deposition [J/(cm2 * s)]", dataKey: "rate_energy_deposition"},
                    ],
                    rows: [{
                        "frequency_MHz": calculatorStore.frequency_MHz,
                        "ppp_mpa": (+calculatorStore.ppp_mpa).toFixed(2),
                        "pnp_mpa": (+calculatorStore.pnp_mpa).toFixed(2),
                        "isppa": (+calculatorStore.isppa).toFixed(2),
                        "non_derated_MI": calculatorStore.non_derated_MI,
                        "ispta of pulse train": calculatorStore.pulseAndTrainOnly ||
                        calculatorStore.allTimeTogglesOn ? (+calculatorStore.ispta_pulse_train).toFixed(2) : '-',
                        "ispta of pulse train repetition": calculatorStore.allTimeTogglesOn ?
                            (+calculatorStore.ispta_pulse_train_repetition).toFixed(2) : '-',
                        // "temp_rise": state.Temp_Rise_C.toFixed(4),
                        "energy_deposition": calculatorStore.energy_deposition,
                        "rate_of_energy_deposition": calculatorStore.rate_of_energy_deposition
                    }]
                },
                derated : {
                    title: 'In Situ Estimates at the Focus with a Conservative Derating',
                    columns: [
                        {title: "Fundamental Frequency", dataKey: "frequency_MHz"},
                        {title: "Pressure Amplitude [MPa]", dataKey: "derated_ppp_mpa"},
                        {title: "Peak Negative pressure [MPa]", dataKey: "derated_pnp_mpa"},
                        {title: "Isppa [W/cm2]", dataKey: "derated_isppa"},
                        {title: "MI derated by 0.3 dB/cm/MHz", dataKey: "MI"},
                        {title: "MI_tc", dataKey: "derated_MI"},
                        {title: "Ispta of pulse train [W/cm2]", dataKey: "derated_ispta_of_pulse_train"},
                        {title: "Ispta of pulse train repetition [W/cm2]", dataKey: "derated_ispta_of_pulse_train_repetition"},
                        {title: "Energy deposition [J/cm2]", dataKey: "energy_deposition"},
                        {title: "Rate of energy deposition [J/(cm2 * s)]", dataKey: "rate_energy_deposition"},

                    ],
                    rows: [{
                        "frequency_MHz": calculatorStore.frequency_MHz,
                        "ppp_mpa": (+calculatorStore.derated_ppp_mpa).toFixed(2),
                        "pnp_mpa": (+calculatorStore.derated_pnp_mpa).toFixed(2),
                        "isppa": (+calculatorStore.derated_isppa).toFixed(2),
                        "MI": (+calculatorStore.MI).toFixed(2),
                        "MI_tc": (+calculatorStore.derated_MI).toFixed(2),
                        "ispta of pulse train": calculatorStore.pulseAndTrainOnly
                        || calculatorStore.allTimeTogglesOn
                            ? (+calculatorStore.derated_ispta_pulse_train).toFixed(2) : '-',
                        "ispta of pulse train repetition": calculatorStore.allTimeTogglesOn
                            ? (+calculatorStore.derated_ispta_pulse_train_repetition).toFixed(2) : '-',
                        "energy_deposition": calculatorStore.derated_energy_deposition,
                        "rate_of_energy_deposition": calculatorStore.derated_rate_of_energy_deposition
                    }]
                },
                timing: {
                    title: 'Timing',
                    columns: [
                        {title: "Pulse duration [ms]", dataKey: "pulse_duration_ms"},
                        {title: "Pulse Ramp duration [ms]", dataKey: "pulse_ramp_duration_ms"},
                        {title: "Pulse Ramp Shape", dataKey: "pulse_ramp_shape"},
                        {title: "Duty Cycle of Pulse", dataKey: "duty_cycle_of_pulse"},
                        {title: "Pulse Repetition interval [ms]", dataKey: "pulse_repetition_interval_ms"},
                        {title: "Pulse Train Duration [ms]", dataKey: "pulse_train_duration_ms"},
                        {title: "Pulse Train Ramp Duration [ms]", dataKey: "pulse_train_ramp_duration_ms"},
                        {title: "Pulse Train Ramp Shape", dataKey: "pulse_train_ramp_shape"},
                        {title: "Duty Cycle of PT", dataKey: "duty_cycle_of_pulse_train"},
                        {title: "Pulse Train Repetition Interval [ms]", dataKey: "pulse_train_repetition_interval_ms"},
                        {title: "Pulse Train Repetition Duration [ms]", dataKey: "pulse_train_repetition_duration_ms"},
                        {title: "Pulse Train Repetition Ramp Duration [ms]", dataKey: "pulse_train_repetition_ramp_duration_ms"},
                        {title: "Pulse Train Repetition Ramp Shape", dataKey: "pulse_train_repetition_ramp_shape"},
                        {title: "Duty Cycle of PTR", dataKey: "duty_cycle_of_pulse_train_repetition"},
                    ],
                    rows: [{
                        "pulse_duration_ms": calculatorStore.pulse_duration_ms,
                        "pulse_ramp_duration_ms": calculatorStore.pulse_ramp_duration_ms,
                        "pulse_ramp_shape": calculatorStore.pulse_ramp_shape,
                        "duty_cycle_of_pulse": calculatorStore.duty_cycle_of_pulse,
                        "pulse_repetition_interval_ms": calculatorStore.pulse_repetition_interval_ms,
                        "pulse_train_duration_ms": calculatorStore.pulse_train_duration_ms,
                        "pulse_train_ramp_duration_ms": calculatorStore.pulse_train_ramp_duration_ms,
                        "pulse_train_ramp_shape": calculatorStore.pulse_train_ramp_shape,
                        "duty_cycle_of_pulse_train": calculatorStore.duty_cycle_of_pulse_train,
                        "pulse_train_repetition_interval_ms": calculatorStore.pulse_train_repetition_interval_ms,
                        "pulse_train_repetition_duration_ms": calculatorStore.pulse_train_repetition_duration_ms,
                        "pulse_train_repetition_ramp_duration_ms": calculatorStore.pulse_train_repetition_ramp_duration_ms,
                        "pulse_train_repetition_ramp_shape": calculatorStore.pulse_train_repetition_ramp_shape,
                        "duty_cycle_of_pulse_train_repetition": calculatorStore.duty_cycle_of_pulse_train_repetition,
                    }]
                },
                heat_deposition: {
                    title: 'Heat Deposition in Tissue',
                    columns: [
                        {title: "TUS Maximum SAR at Focus [W/kg]", dataKey: "TUS_Max_SAR_at_Focus"},
                        {title: "TUS Geometry Factor at Focus", dataKey: "TUS_Geometry_Factor_at_Focus"},
                        {title: "TUS SAR at Focus Averaged over 10 gm or 10 cc [W/kg]", dataKey: "TUS_SAR_at_Focus_averaged"},
                        {title: "MR SAR Averaged over 10 gm or 10 cc [W/kg]", dataKey: "MR_SAR"},

                        {title: "Max. Temp Rise during Chosen US Protocol [°C]", dataKey: "max_temp_rise_us_protocol"},
                        {title: "Max. Temp Rise in Steady State [°C]", dataKey: "max_temp_rise_steady_state"},
                        {title: "Max. Thermal Dose [min. at 43 °C]", dataKey: "max_thermal_dose"},

                        {title: "TIC in the skull [mW/cm]", dataKey: "getTIC"},
                        {title: "Total SAR Averaged over 10 gm or 10 cc [W/kg]", dataKey: "totalSARAveragedOver10gmOr10ccWkg"},
                        {title: "SAR for Temperature Calculation [W/kg]", dataKey: "SARforTemperatureCalculation"},

                        {title: "Graph Duration", dataKey: "exposure_time"},
                        {title: "Graph Duration Time Unit", dataKey: "tempRiseTimeUnit"},
                    ],
                    rows: [{
                        "TUS_Max_SAR_at_Focus": +(+calculatorStore.TUS_Max_SAR_at_Focus).toFixed(2),
                        "TUS_Geometry_Factor_at_Focus": calculatorStore.TUS_Geometry_Factor_at_Focus,
                        "TUS_SAR_at_Focus_averaged": (+calculatorStore.TUS_SAR_at_Focus_averaged).toFixed(2),
                        "MR_SAR": calculatorStore.MR_SAR,

                        "max_temp_rise_us_protocol": (+calculatorStore.max_temp_rise_us_protocol).toPrecision(3),
                        "max_temp_rise_steady_state": (+calculatorStore.max_temp_rise_steady_state).toPrecision(3),
                        "max_thermal_dose": (+calculatorStore.max_thermal_dose).toFixed(2),

                        "getTIC":  +calculatorStore.getTIC.toFixed(2),
                        "totalSARAveragedOver10gmOr10ccWkg": calculatorStore.totalSARAveragedOver10gmOr10ccWkg.toFixed(2),
                        "SARforTemperatureCalculation": (+calculatorStore.SAR_for_Temperature_Calculation).toFixed(2),

                        "exposure_time": calculatorStore.isManualExposureTime ? +calculatorStore.overallExposureTimeManual
                            : +calculatorStore.overallExposureTime,
                        "exposure_time_unit": calculatorStore.tempRiseTimeUnit,
                    }]
                },
                acoustic_power: {
                    title: 'Acoustic Power',
                    columns: [
                        {title: "Total Electrical Power [mW]", dataKey: "electrical_power"},
                        {title: "Transducer efficiency [%]", dataKey: "transducer_efficiency"},
                        {title: "Total Acoustic Power [mW]", dataKey: "acoustic_power"},
                        {title: "Average Acoustic Power [mW]", dataKey: "avg_acoustic_power"},
                    ],
                    rows: [{
                        "electrical_power": +calculatorStore.electrical_power,
                        "transducer_efficiency": +calculatorStore.transducer_efficiency,
                        "acoustic_power": +calculatorStore.acoustic_power,
                        "avg_acoustic_power": +calculatorStore.average_acoustic_power
                    }]
                },
                assumptions: {
                    title: 'Acoustic Properties',
                    columns: [
                        {title: "Density Free-Field ("+calculatorStore.selectedFreeFieldWaterProperties+") [kg/m3]", dataKey: "rho_kg_m3_FF"},
                        {title: "Speed of Sound Free-Field ("+calculatorStore.selectedFreeFieldWaterProperties+") [m/s]", dataKey: "c_m_s_FF"},
                        {title: "Acoustic Impedance Free-Field [kg/(mm2*s)]", dataKey: "z_Rayl_FF"},

                        {title: "Density In Situ ("+calculatorStore.selectedInSituWaterProperties+") [kg/m3]", dataKey: "rho_kg_m3_IS"},
                        {title: "Speed of Sound In Situ ("+calculatorStore.selectedInSituWaterProperties+") [m/s]", dataKey: "c_m_s_IS"},
                        {title: "Acoustic Impedance In Situ [kg/(mm2*s)]", dataKey: "z_Rayl_IS"},
                    ],
                    rows: [{
                        "rho_kg_m3_FF": (+calculatorStore.rho_kg_m3_FF).toFixed(2),
                        "c_m_s_FF": (+calculatorStore.c_m_s_FF).toFixed(2),
                        "z_Rayl_FF": (+calculatorStore.z_Rayl_FF).toFixed(2),
                        "rho_kg_m3_IS": (+calculatorStore.rho_kg_m3_IS).toFixed(2),
                        "c_m_s_IS": (+calculatorStore.c_m_s_IS).toFixed(2),
                        "z_Rayl_IS": (+calculatorStore.z_Rayl_IS).toFixed(2),
                    }]
                },
                derating_values: {
                    title: 'Derating Parameters',
                    columns: [
                        {title: "Diameter of transducer [mm]", dataKey: "diameter_of_transducer_mm"},
                        {title: "Coupling thickness [mm]", dataKey: "coupling_thickness_mm"},
                        {title: "Scalp thickness [mm]", dataKey: "thickness_of_scalp_mm"},
                        {title: "Skull thickness [mm]", dataKey: "thickness_of_skull_mm"},
                        {title: "Focal depth [mm]", dataKey: "focal_depth_mm"},
                        {title: "US beam diameter on skin [mm]", dataKey: "us_beam_diameter_on_skin_mm"},
                        {title: "US beam diameter on skull [mm]", dataKey: "us_beam_diameter_on_skull_mm"},
                        {title: "Skull pressure transmission [-]", dataKey: "skull_pressure_transmission"},
                        {title: "Brain pressure transmission [-]", dataKey: "brain_pressure_transmission"},
                        {title: "Attenuation coefficient [dB/cm/MHz]", dataKey: "absorptionAttenuationCoefficient"},
                        {title: "Absorption attenuation coefficient [dB/cm/MHz]", dataKey: "absorptionAttenuationCoefficient"},
                        {title: "Brain absorption fraction [-]", dataKey: "absorptionFraction"}
                    ],
                    rows: [{
                        "diameter_of_transducer_mm": calculatorStore.diameter_of_transducer_mm,
                        "coupling_thickness_mm": calculatorStore.coupling_thickness_mm,
                        "thickness_of_scalp_mm": calculatorStore.thickness_of_scalp_mm,
                        "thickness_of_skull_mm": calculatorStore.thickness_of_skull_mm,
                        "focal_depth_mm": calculatorStore.focal_depth_mm,
                        "us_beam_diameter_on_skin_mm": calculatorStore.us_beam_diameter_on_skin_mm,
                        "us_beam_diameter_on_skull_mm": calculatorStore.us_beam_diameter_on_skull_mm,
                        "skull_pressure_transmission": calculatorStore.isManualSkullPressureTransmission ? calculatorStore.skull_pressure_transmission_manual : calculatorStore.skull_pressure_transmission,
                        "brain_pressure_transmission": calculatorStore.isManualBrainPressureTransmission ? calculatorStore.brain_pressure_transmission_manual : calculatorStore.brain_pressure_transmission,
                        "attenuation_coefficient": calculatorStore.attenuation_coefficient,
                        "absorptionAttenuationCoefficient": calculatorStore.absorptionAttenuationCoefficient,
                        "absorptionFraction":  calculatorStore.absorptionFraction
                    }]
                }
            }
        },
    },
    actions: {
        validateImportJson(newState) {
            const message = `The pressure transmission and the attenuation coefficient are dependent on each other. 
             You can only import a modified value for one of them at a time. Please modify your import file to reflect 
             those changes.`

            if ((newState.isManualBrainPressureTransmission
                && newState.isManualBrainAttenuationCoeff)) {
                Dialog.create({
                    title: 'Brain pressure transmission and brain attenuation coefficient dependency',
                    message: message,
                    persistent: true,
                    html: false,
                    color: 'primary',
                    dark: this.isDarkModeGlobal
                })
                return false
            }
            return true;
        },
        mapToStateKeys(obj) {
            const newObj = {};

            for (const key in obj) {
                if (Object.hasOwn(obj, key)) {
                    // Find the state key (e.g., "Fundamental Frequency [MHz]" -> "frequency_MHz")
                    const stateKey = mappingTable[key] || key;
                    const rawValue = obj[key];

                    // 1. Handle Booleans: Check "is" prefix but exclude "isppa"
                    if (stateKey.startsWith("is") && stateKey !== "isppa") {
                        // Handle both actual booleans and string "true"/"false"
                        newObj[stateKey] = rawValue === true || rawValue === 'true';
                    }

                    // Ensure 0 is treated as a number and not a falsy skip
                    else if (typeof rawValue === 'number' || (rawValue !== '' && !isNaN(Number(rawValue)))) {
                        newObj[stateKey] = Number(rawValue);
                    }

                    else if (typeof rawValue !== 'boolean' && rawValue !== '' && !isNaN(Number(rawValue))) {
                        newObj[stateKey] = Number(rawValue);
                    }

                    // 3. Fallback: Keep as is (for strings like "Linear", "Tukey", "Water")
                    else {
                        newObj[stateKey] = rawValue;
                    }
                }
            }
            return newObj;
        },
        exportState(format, filename) {
            const calculatorStore = useCalculatorStore()
            const exportData = {};

            Object.keys(schema).forEach(stateKey => {
                const label = schema[stateKey];
                let value = calculatorStore[stateKey];

                // Special handling for conditional fields (Manual vs. Calculated)
                if (stateKey === 'overallExposureTimeManual' && !calculatorStore.isManualExposureTime) {
                    value = calculatorStore.overallExposureTime;
                }
                if (stateKey === 'skull_pressure_transmission_manual' && !calculatorStore.isManualSkullPressureTransmission) {
                    value = calculatorStore.skull_pressure_transmission;
                }
                if (stateKey === 'brain_pressure_transmission_manual' && !calculatorStore.isManualBrainPressureTransmission) {
                    value = calculatorStore.brain_pressure_transmission;
                }

                // Apply number casting for numeric types to match your current +calculatorStore logic
                exportData[label] = (typeof value === 'number') ? +value : value;
            });

            if (format === 'json') {
                this.writeToFile(JSON.stringify(exportData, null, 2), format, 'application/json', filename)
            }

            if (format === 'yml') {
                const yamlString = this.dumpToYAML(exportData, '\r\n')
                this.writeToFile(yamlString, format, 'application/x-yaml', filename)
            }
        },
        dumpToYAML(obj, lineEnding = lineEnding) {
            return Object.entries(obj)
                .map(([key, value]) => `${key}: ${value}`)
                .join(lineEnding);
        },
        writeToFile(jsonString, format, fType, filename) {
            const blob = new Blob([jsonString], {type: fType})
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.href = url;
            a.download = filename + '.' + format
            document.body.appendChild(a);

            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
    // Improved PDF generation methods for better layout
    // Enhanced PDF generation with flipped tables (parameters as rows, values as columns)
    createFlippedTable(doc, configObject, startY) {
        // Add section title if provided
        if (configObject.title) {
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(52, 73, 94);
            doc.text(configObject.title, 30, startY - 5);
            startY += 5;
        }

        // Calculate available width
        const pageWidth = doc.internal.pageSize.width;
        const margins = { left: 30, right: 30 };
        const availableWidth = pageWidth - margins.left - margins.right;

        // Create flipped table data
        const tableData = [];
        const rowData = configObject.rows[0];

        configObject.columns.forEach((column, index) => {
            const parameterName = column.title;
            const value = Object.values(rowData)[index];
            tableData.push([parameterName, value.toString()]);
        });

        // Calculate column widths - parameter column wider than value column
        const parameterColumnWidth = availableWidth * 0.7; // 70% for parameter names
        const valueColumnWidth = availableWidth * 0.3; // 30% for values

        autoTable(doc, {
            startY: startY,
            body: tableData,
            styles: {
                lineColor: [200, 200, 200],
                lineWidth: 0.3,
                fontSize: 9,
                cellPadding: 6,
                halign: 'left',
                valign: 'middle',
                overflow: 'linebreak'
            },
            headStyles: {
                fillColor: [52, 73, 94], // Professional dark blue
                textColor: 255,
                fontStyle: 'bold',
                fontSize: 10,
                halign: 'center'
            },
            bodyStyles: {
                fillColor: [248, 249, 250], // Very light gray
                textColor: [44, 62, 80]
            },
            columnStyles: {
                0: { // Parameter column
                    cellWidth: parameterColumnWidth,
                    fontStyle: 'normal',
                    halign: 'left'
                },
                1: { // Value column
                    cellWidth: valueColumnWidth,
                    fontStyle: 'bold',
                    halign: 'right',
                    fillColor: [255, 255, 255] // White background for values
                }
            },
            alternateRowStyles: {
                fillColor: [252, 252, 252] // Slightly different alternating color
            },
            margin: margins,
            theme: 'striped',
            tableWidth: 'auto'
        });

        // Return the final Y position for next table
        return doc.lastAutoTable.finalY + 25;
    },

    // Special method for timing table with hierarchical structure
    createTimingTable(doc, configObject, startY, title = null) {
        if (title) {
            doc.setFontSize(12)
            doc.setFont('helvetica', 'bold')
            doc.setTextColor(52, 73, 94)
            doc.text(title, 30, startY - 10)
            startY += 5
        }

        const pageWidth = doc.internal.pageSize.width
        const margins = { left: 30, right: 30 }
        const availableWidth = pageWidth - margins.left - margins.right
        const parameterColumnWidth = availableWidth * 0.7
        const valueColumnWidth = availableWidth * 0.3

        // Group timing parameters by category
        const rowData = configObject.rows[0]
        const timingGroups = [
            {
                title: 'Basic Pulse Parameters',
                params: [
                    'pulse_duration_ms',
                    'pulse_ramp_duration_ms',
                    'pulse_ramp_shape',
                    'duty_cycle_of_pulse'
                ]
            },
            {
                title: 'Pulse Train Parameters',
                params: [
                    'pulse_repetition_interval_ms',
                    'pulse_train_duration_ms',
                    'pulse_train_ramp_duration_ms',
                    'pulse_train_ramp_shape',
                    'duty_cycle_of_pulse_train'
                ]
            },
            {
                title: 'Pulse Train Repetition Parameters',
                params: [
                    'pulse_train_repetition_interval_ms',
                    'pulse_train_repetition_duration_ms',
                    'pulse_train_repetition_ramp_duration_ms',
                    'pulse_train_repetition_ramp_shape',
                    'duty_cycle_of_pulse_train_repetition'
                ]
            }
        ]

        let currentY = startY

        timingGroups.forEach((group, groupIndex) => {
            // Add group header
            if (groupIndex > 0) currentY += 15 // Space between groups

            doc.setFontSize(10)
            doc.setFont('helvetica', 'bold')
            doc.setTextColor(52, 73, 94)
            doc.text(group.title, 30, currentY)
            currentY += 15

            // Create table data for this group
            const groupTableData = []
            group.params.forEach(paramKey => {
                const column = configObject.columns.find(col => col.dataKey === paramKey)
                if (column) {
                    const value = rowData[paramKey]
                    groupTableData.push([column.title, value.toString()])
                }
            });

            // Create mini table for this group
            autoTable(doc, {
                startY: currentY,
                body: groupTableData,
                styles: {
                    lineColor: [200, 200, 200],
                    lineWidth: 0.3,
                    fontSize: 9,
                    cellPadding: 4,
                    halign: 'left',
                    valign: 'middle',
                    overflow: 'linebreak'
                },
                bodyStyles: {
                    fillColor: [248, 249, 250],
                    textColor: [44, 62, 80]
                },
                columnStyles: {
                    0: {
                        cellWidth: parameterColumnWidth,
                        fontStyle: 'normal',
                        halign: 'left'
                    },
                    1: {
                        cellWidth: valueColumnWidth,
                        fontStyle: 'bold',
                        halign: 'right',
                        fillColor: [255, 255, 255]
                    }
                },
                alternateRowStyles: {
                    fillColor: [252, 252, 252]
                },
                margin: margins,
                theme: 'striped',
                showHead: false
            })

            currentY = doc.lastAutoTable.finalY + 10
        })

        return currentY + 15
    },

    addPageHeader(doc, pageNumber) {
        doc.setFontSize(18)
        doc.setFont('helvetica', 'bold')
        doc.setTextColor(52, 73, 94)
        doc.text("TUS Calculator Results", 40, 45)

        doc.setFontSize(11)
        doc.setFont('helvetica', 'normal')
        doc.setTextColor(108, 117, 125)
        doc.text(`Generated: ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}`, 40, 60)

        // Page number (right aligned)
        doc.text(`Page ${pageNumber}`, doc.internal.pageSize.width - 80, 45)

        // Add a styled line under header
        doc.setDrawColor(52, 73, 94)
        doc.setLineWidth(1)
        // // doc.line(40, 70, doc.internal.pageSize.width - 40, 70);

        // Reset colors
        doc.setTextColor(0, 0, 0)

        return 85;
    },

    addDisclaimer(doc, startY) {
        // Check if we need a new page for disclaimer
        if (startY > doc.internal.pageSize.height - 250) {
            doc.addPage()
            startY = this.addPageHeader(doc, 2)
        }

        doc.setFontSize(12)
        doc.setFont('helvetica', 'bold')
        doc.setTextColor(52, 73, 94)
        doc.text('Important Disclaimer', 40, startY)

        doc.setFontSize(9)
        doc.setFont('helvetica', 'normal')
        doc.setTextColor(44, 62, 80)

        const disclaimerText = `This calculator is solely developed to estimate derived quantities like ultrasound intensity and mechanical index, which have consequences for both safety and efficacy of ultrasound protocols.
    
    It does not account for individual differences in anatomy, and is not intended to, and should not be used to, replace an individualized acoustic simulation.
    
    The calculator is not intended to be and should not be used as a medical device as defined in the Medical Device Regulation (Regulation (EU) 2017/745).
    
    Use of the calculator is at one's own risk: the calculator is provided "as is", without warranty of any kind, express or implied, including but not limited to the warranties of merchantability, safety, fitness for a particular purpose and noninfringement of any rights.
    
    In no event shall the creators, authors or copyright holders be liable for any claim, damages or other liability, arising from, out of or in connection with the calculator or the use of the calculator or data generated with or with the help of the calculator.`;

    const maxWidth = doc.internal.pageSize.width - 80;
    const lines = doc.splitTextToSize(disclaimerText, maxWidth);

    let currentY = startY + 20;
    lines.forEach(line => {
        if (currentY > doc.internal.pageSize.height - 50) {
            doc.addPage();
            currentY = this.addPageHeader(doc, 3);
        }
        doc.text(line, 40, currentY);
        currentY += 12;
    });
},
    async generatePDF() {
    const doc = new jspdf('p', "pt", 'a4');
    let currentY = this.addPageHeader(doc, 1)
    let pageNumber = 1

    // Helper function to check if we need a new page
    const checkNewPage = (requiredSpace) => {
        if (currentY + requiredSpace > doc.internal.pageSize.height - 80) {
            doc.addPage()
            pageNumber++
            currentY = this.addPageHeader(doc, pageNumber)
        }
    };

    // Generate flipped tables
    const tableConfigsBeforeTiming = [
        {
            config: this.tableConfigurations.notderated,
            estimatedSpace: 200
        },
        {
            config: this.tableConfigurations.derated,
            estimatedSpace: 200
        }
    ]

    // Timing params in between

    const tableConfigsAfterTiming = [
        {
            config: this.tableConfigurations.heat_deposition,
            estimatedSpace: 220
        },
        {
            config: this.tableConfigurations.acoustic_power,
            estimatedSpace: 220
        },
        {
            config: this.tableConfigurations.assumptions,
            estimatedSpace: 100
        },
        {
            config: this.tableConfigurations.derating_values,
            estimatedSpace: 250
        }
    ];

    // Generate regular flipped tables
    for (const tableConfig of tableConfigsBeforeTiming) {
        checkNewPage(tableConfig.estimatedSpace);
        currentY = this.createFlippedTable(doc, tableConfig.config, currentY)
    }

    // Special handling for timing table with grouping
    checkNewPage(300);
    currentY = this.createTimingTable(doc, this.tableConfigurations.timing, currentY, 'Timing Parameters');

        // Generate regular flipped tables
    for (const tableConfig of tableConfigsAfterTiming) {
        checkNewPage(tableConfig.estimatedSpace);
        currentY = this.createFlippedTable(doc, tableConfig.config, currentY);
    }
    // Add disclaimer
    checkNewPage(250);
    this.addDisclaimer(doc, currentY);

    // Add professional footer to all pages
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(108, 117, 125);

        // Footer line
        doc.setDrawColor(220, 220, 220);
        doc.setLineWidth(0.5);
        // // doc.line(40, doc.internal.pageSize.height - 40, doc.internal.pageSize.width - 40, doc.internal.pageSize.height - 40);

        // Footer text
        doc.text(`TUS Calculator Report - Page ${i} of ${totalPages}`,
                 doc.internal.pageSize.width / 2,
                 doc.internal.pageSize.height - 25,
                 { align: 'center' });
    }

        await doc.save("TUS-calculator-results.pdf", {
            returnPromise: true
        })
    },
    async generateZIP () {
        const csvString = this.generateCSVstring();
        // 1. Add the UTF-8 BOM (Byte Order Mark)
        const BOM = '\uFEFF';

        const finalContent = BOM + csvString;

        const zip = new JSZip()
        zip.file("TUS-calculator.csv", finalContent)
        zip.generateAsync({type:"blob"}).then(function(content) {
            FileSaver.saveAs(content, 'download.zip')
        })
    },
    generateCSVstring() {
        const separator = ','
        const lineEnding = '\n'

        const tableConfigKeys = [
            'notderated',
            'derated',
            'timing',
            'heat_deposition',
            'acoustic_power',
            'assumptions',
            'derating_values'
        ];

        const formatTitle = key =>
            key
                .replace(/_/g, ' ')                 // Replace underscores with spaces
                .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters if camelCase
                .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word

        let lines = [];

        tableConfigKeys.forEach((key, index) => {
            const table = this.tableConfigurations[key];
            const titles = table.columns.map(col => col.title);
            const values = Object.values(table.rows[0]);

            // Add section title, capitalized and spaced
            lines.push(`${formatTitle(this.tableConfigurations[key].title)}${separator}`);

            // Add each parameter-value pair
            titles.forEach((title, i) => {
                lines.push(title + separator + values[i]);
            });

            // Add an empty row between tables (except after the last one)
            if (index < tableConfigKeys.length - 1) {
                lines.push('');
            }
        });

        return lines.join(lineEnding) + lineEnding;
    },
    async exportResults(format) {
            format === 'pdf'
                ? await this.generatePDF()
                : await this.generateZIP()
        }
    }
})